// extracted by mini-css-extract-plugin
module.exports = {"burgerWrapper":"constructor_burgerWrapper__2VnEV"};